import { render, staticRenderFns } from "./AddEventSubType.vue?vue&type=template&id=2505f2f3"
import script from "./AddEventSubType.vue?vue&type=script&lang=js"
export * from "./AddEventSubType.vue?vue&type=script&lang=js"
import style0 from "./AddEventSubType.vue?vue&type=style&index=0&id=2505f2f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports